@if (showSearch) {
  <div class="form-group">
    <cpq-input [label]="{key: labelAvailable.key, placeholder: labelAvailable.placeholder}"
      #searchAvailableItems="ngModel" [name]="'searchAvailableItems'" [(ngModel)]='searchKeywordAvaible'
    (ngModelChange)="searchAvailable()" (focusout)="hasSearchResults=true"></cpq-input>
    <span [ngClass]="{'sap-icon': true, 'search-icon': !searchKeywordAvaible, 'close-icon': searchKeywordAvaible}"
    (click)="clearAttributeSearchInput()"></span>
    @if (!hasSearchResults) {
      <ul class="no-results">
        <li>
          {{'Admin.Msg.NoResultsSearch' | translate}}
        </li>
      </ul>
    }
  </div>
}
@if (labelLink) {
  <p class="text-left input-group no-top-margin">
    <a (click)="onLinkClick($event)">
      {{labelLink.key | translate}}
      @if (labelHelp) {
        <cpq-info [message]="labelHelp" class="cpq-info-icon"></cpq-info>
      }
    </a>
  </p>
}
<div>
  @if (isMultilevelList) {
    <ul class="main-list">
      @for (group of multiLevelFilteredItems; track group) {
        <li>
          <div class="text-container multi-list-wrapper" (click)="collapseExpand(group)">
            <span>
              <span [ngClass]="{'sap-icon dropdown-icon': true, 'rotate': !group.isCollapsed}">&#xe066;</span>
              <span class="main-item">{{group.name}}</span>
            </span>
          </div>
          @if (group.children && !group.isAsync) {
            <ul>
              <cdk-virtual-scroll-viewport [id]="group.id" [itemSize]="itemHeight" [minBufferPx]="itemsContainerMaxHeight"
                [maxBufferPx]="itemsContainerMaxHeight" [ngClass]="{'expanded cpq-scroll' : !group.isCollapsed}"
                [ngStyle]="{'height': group.children.length <= 9 ? group.children.length * itemHeight + 'px' : itemsContainerMaxHeight + 'px'}">
                <ng-container *cdkVirtualFor="let child of group.children; let i = index">
                  <ng-container *ngTemplateOutlet='itemTemplate ? itemTemplate : defaultItemTemplate; context: {item: child, group: group}'></ng-container>
                </ng-container>
              </cdk-virtual-scroll-viewport>
            </ul>
          }
        </li>
      }
    </ul>
  } @else {
    @if (basicFilteredItems) {
      <ul class="selected-list">
        <cdk-virtual-scroll-viewport id="itemsList" class='expanded cpq-scroll' [itemSize]="itemHeight" [minBufferPx]="itemsContainerMaxHeight"
          [maxBufferPx]="itemsContainerMaxHeight"
          [ngStyle]="{'height': basicFilteredItems.length <= 9 ? basicFilteredItems.length * itemHeight + 'px' : itemsContainerMaxHeight + 'px'}">
          <ng-container *cdkVirtualFor="let item of basicFilteredItems">
            <ng-container *ngTemplateOutlet='itemTemplate ? itemTemplate : defaultItemTemplate; context: {item: item}'></ng-container>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </ul>
    }
  }



  <ng-template #defaultItemTemplate let-item='item' let-group='group'>
    <li [ngClass]="{'expanded' : !group || !group.isCollapsed}" class="child-item" (click)="select(item, $event)">
      <div class="text-container" [class.selected]="item.isSelected">
        <span class="title-container" [title]='item.name'>{{item.name}}</span>
        <div class="arrow-container" [class.selected]="item.isSelected">
          <span class="sap-icon">&#xe05b;</span>
        </div>
      </div>
    </li>
  </ng-template>
</div>